import './ChecklistPreview.scss';
import { prefixClass } from 'lib/utils';

import React, { FC } from 'react';

import CheckList from 'presentation/components/KSQ2/Common/CheckList/CheckList';
import type { ChecklistPreviewExtra } from 'presentation/components/KSQ2/Cards/MessagesCard/subcomponents/MessageContent/analyzeMessageContent';

type PrefixClassName = (element?: string) => string;

export interface ChecklistPreviewProps {
  checklist: ChecklistPreviewExtra['checklist'];
}

const ChecklistPreview: FC<ChecklistPreviewProps> = ({ checklist }) => {
  const prefix = prefixClass('q2-message-preview-module-checklist');
  return (
    <div className={prefix()}>
      <CheckList items={checklist} editable={false} />
    </div>
  );
};

export default ChecklistPreview;
